import React, { PureComponent as Component } from 'react';
import { Button } from 'reactstrap';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Toolbars as ToolBarContainer } from '../../../../components/Card/CardHeaderWithToolbars'

export default class Toolbars extends Component {
  render(){
    return(
      <ToolBarContainer>
        <Link 
          to={'/vouchers/create'} 
          className="btn btn-sm btn-primary with-toolbars__toolbars__btn" 
          title="Create new voucher"
          target="_blank"
        >
          <i className="fa fa-plus"></i>
        </Link>
        <Button
          title="Bulk upload vouchers"
          className="with-toolbars__toolbars__btn"
          size="sm"
          color="success"
          onClick={this.props.onBulkUpload}>
          <i className="fa fa-upload"></i>
        </Button>
        <Button
          title="Export vouchers"
          className="with-toolbars__toolbars__btn"
          size="sm"
          color="secondary"
          disabled={this.props.exporting}
          onClick={this.props.onExport}>
          <i className={classNames("fa",{"fa-download":!this.props.exporting,"fa-spinner fa-spin":this.props.exporting})}></i>
        </Button>
        <Button
          title="Bulk manage by group (activate / deactivate / delete)"
          className="with-toolbars__toolbars__btn"
          size="sm"
          color="dark"
          onClick={this.props.onBulkManage}>
          <i className="fa fa-cogs"></i>
        </Button>
        <Button
          title="Bulk edit by group"
          className="with-toolbars__toolbars__btn"
          size="sm"
          color="warning"
          onClick={this.props.onBulkEdit}>
          <i className="fa fa-pencil"></i>
        </Button>
        <Button
          title="Refresh"
          className="with-toolbars__toolbars__btn"
          size="sm"
          color="info"
          onClick={this.props.onRefreshList}>
          <i className="fa fa-refresh"></i>
        </Button>
        <Button 
          title="Reset filter"
          className="with-toolbars__toolbars__btn"
          size="sm"
          color="warning"
          onClick={this.props.onResetFilter}> 
          <i className="fa fa-ban"></i>
        </Button>
        <Button 
          title="Search and Filter Data"
          size="sm"
          className={classNames("with-toolbars__toolbars__btn",{"btn-danger":this.props.isOpen})} 
          onClick={this.props.onToggleFilter}> 
          <i className={classNames("fa",{"fa-sliders":!this.props.isOpen, "fa-minus":this.props.isOpen})}></i>
        </Button>
      </ToolBarContainer>
    )
  }
}

Toolbars.propTypes = {
  isOpen: propTypes.bool,
  onToggleFilter: propTypes.func,
  onResetFilter: propTypes.func,
  onRefreshList: propTypes.func,
  onBulkUpload: propTypes.func,
  onBulkManage: propTypes.func,
  onBulkEdit: propTypes.func,
  onExport: propTypes.func,
  exporting: propTypes.bool
}
Toolbars.defaultProps = {
  isOpen: false
}